import { Email, Phone } from '@mui/icons-material';
import {
  Modal,
  ModalDialog,
  ModalClose,
  Typography,
  useTheme,
  Theme,
} from '@mui/joy';
import { tss } from 'tss-react';
import React from 'react';

interface ContactModalProps {
  advisorName: string | undefined;
  advisorEmail: string | undefined;
  advisorPhone: string | undefined;
  onClose: () => void;
}

const useStyles = tss
  .withParams<{ theme: Theme }>()
  .create(({ theme }) => ({
    contactRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  }));

export function ContactModal({
  advisorName,
  advisorEmail,
  advisorPhone,
  onClose,
}: ContactModalProps) {
  const theme = useTheme();
  const { classes } = useStyles({ theme });
  return (
    <Modal open onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <Typography level='h4'>Contact M&A Advisor</Typography>
        <Typography level='body-md'>
          The advisor for this listing is <b>{advisorName || 'Ori Eldarov'}</b>.
        </Typography>
        <Typography level='body-md' className={classes.contactRow}>
          <Email /> {advisorEmail || 'ori@offdeal.com'}
        </Typography>
        <Typography level='body-md' className={classes.contactRow}>
          <Phone /> {advisorPhone || '(646) 480-9906'}
        </Typography>
      </ModalDialog>
    </Modal>
  );
}
